import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { useTranslation } from '../../contexts/translation-context';
import { TextField } from '../../ui/text-field';
const FullNameFirstName = props => {
  const fieldType = FIELD_TYPES.FULL_NAME_FIRST_NAME;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    fieldType: fieldType,
    label: t('locale-dataset.addressParts.default.firstName')
  }));
};
export default FullNameFirstName;
//# sourceMappingURL=full-name-first-name.js.map